export const _max_timestamp = 60 * 60 * 1000 - 1;
export const _max_timestamp_leap_seconds = 3600999; // Supports leap second (59: 60.999)
export const _half_of_max_timestamp = 1799999;
export const _delay_of_invalid_timestamp = 9999999;

export function calcDelay(since: number, to: number) {
    if (!(0 <= since && since <= _max_timestamp_leap_seconds)) {
        return _delay_of_invalid_timestamp;
    }

    if (since > to + _half_of_max_timestamp) {
        if (since > _max_timestamp) {
            return to + _max_timestamp_leap_seconds + 1 - since;
        }
        return to + _max_timestamp + 1 - since;
    }

    return to - since;
}
